import { render, staticRenderFns } from "./edit-jifen.vue?vue&type=template&id=4bd1ebb4"
import script from "./edit-jifen.vue?vue&type=script&lang=js"
export * from "./edit-jifen.vue?vue&type=script&lang=js"
import style0 from "./edit-jifen.vue?vue&type=style&index=0&id=4bd1ebb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports